import Skeleton from '../../Skeleton';

/**
 * Mirrors KpiSpotlightBannerShell's structure, with each bar sized to exactly fill its line's
 * height (24px for the title's ambient 16px/1.5 line-height, 20px for the description's `text-sm`)
 * rather than a smaller bar centered inside a taller line box. A shorter, vertically-centered bar
 * looks fine on its own, but real text sits higher within the same line box than a centered bar
 * does — swapping one for the other reads as the content "jumping up." Filling the full line
 * height removes that slack entirely, so there's nothing left to misalign.
 */
const KpiSpotlightBannerSkeleton = () => (
  <div className="flex items-center gap-4 rounded-md border border-gray-200 p-4">
    <div className="flex min-w-0 flex-1 items-start gap-3">
      <Skeleton className="mt-0.5 h-5 w-5 shrink-0 rounded-full" shadow={false} />
      <div className="min-w-0 flex-1">
        <Skeleton className="h-6 w-64 max-w-full" shadow={false} />
        <Skeleton className="mt-0.5 h-5 w-48 max-w-full" shadow={false} />
      </div>
    </div>
    <Skeleton className="h-8 w-32 shrink-0 rounded-full" shadow={false} />
  </div>
);

export default KpiSpotlightBannerSkeleton;
